import 'components/user/avatar';
import './index.scss';
import 'images/tracks/direcao-icon.svg';
import 'images/tracks/direcao.svg';

(function ($) {
  function init() {
    function handleOutsideClick(event, $element, $Toggle, $ToggleInput) {
      if ($(event.target).closest($element).length === 0 &&
        $(event.target).closest($Toggle).length === 0 &&
        $(event.target).closest($ToggleInput).length === 0 &&
        ($element.length && !$element.is(':hover'))) {
        $ToggleInput.prop('checked', false);
      }
    }

    $(document)
      .off('click.header')
      .on('click.header', event => {
        const $segmentsMenu = $('#js-segments-menu');
        const $segmentsMenuToggle = $('.js-segments-menu-toggle');
        const $segmentsMenuToggleInput = $('#segments-toggle-input');

        const $search = $('#js-header-search');
        const $searchToggle = $('.js-header-search-toggle');
        const $searchToggleInput = $('#search-toggle-input');

        handleOutsideClick(event, $segmentsMenu, $segmentsMenuToggle, $segmentsMenuToggleInput);
        handleOutsideClick(event, $search, $searchToggle, $searchToggleInput);
      });
  }

  // Calling it
  init();
  $(document).on('turbolinks:load', () => init());

})(jQuery);
